import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

import Search from '../../search'
import {AddressType, Errors} from "../../const";

const Log = new Logger("StoreLocator/GoogleSearch");

class GoogleSearch extends Search {

  get DefaultOptions() {
    return {};
  }

  // GoogleSearch(...).then((res) => res);

  constructor(provider, element, options) {
    super(provider, element)


    let p = new Promise( (resolve, reject) => {

      this.Geocoder = new google.maps.Geocoder();
      this.autocomplete = new google.maps.places.Autocomplete(this.$element[0], $.extend(true, {}, options || {}));

      this.autocomplete.addListener('place_changed', () => {

        let result = this.autocomplete.getPlace();

        if ( result.place_id ) {
          // We have found a valid Google address
          this.provider.trigger('change-address', result.formatted_address, {
                    lat: result.geometry.location.lat(),
                    lng: result.geometry.location.lng(),
                    bounds: JSON.parse( JSON.stringify( result.geometry.viewport )),
                    _type:                       (
                           [
                              // google.maps.GeocoderLocationType.APPROXIMATE,
                              google.maps.GeocoderLocationType.RANGE_INTERPOLATED,
                              google.maps.GeocoderLocationType.ROOFTOP
                            ].indexOf( result.types[0] ) > -1
                        ) ? AddressType.PointOnMap : AddressType.Generic
          });

        } else {
          // User typed an invalid place. we have to simulate a navigation
          this.provider.navigate( result.name ).then( () => {
            // success callback handled by 'change-address' event
          }, () => {
            this.provider.trigger('change-address', result.name, null );
          });
        }
      });

      // Use GoogleAutocompleteService
      this.Search = new google.maps.places.AutocompleteService();

      resolve(this);

    });

    return p;
  }


  /**
   * @Override
   */
  search(str) {
    return new Promise( (resolve, reject) => {

      // Search address
      this.Search.getPlacePredictions({ input: str, types: ['geocode'] }, function(predictions, status){

        Log.l("Results", predictions);

        // catch error
        predictions = predictions || [];

        let result = [];
        predictions.forEach(function(prediction) {
          result.push({
            main: prediction.structured_formatting ? prediction.structured_formatting.main_text : prediction.description,
            other: prediction.structured_formatting ? prediction.structured_formatting.secondary_text : ""
          });
        });

        resolve(result);
      });
    });

  }

  processOnPlaceChangeResult(placeChangeResult,fallbackObj,clicked){
    const result=(placeChangeResult && placeChangeResult[0]) || fallbackObj
    let searchedCountry = "";
    const address_text = result.formatted_address || result.name;
    let geolocation = null;
    let isCity = null;
    const locationToPatch={};

    //check if location is administrative_area_level_3
    let resType = result.address_components;

    for(let item of resType) {
      if (item.types[0] === 'administrative_area_level_3' || item.types[0] === 'administrative_area_level_2' || item.types[0] === 'administrative_area_level_1') {
        isCity =  true;
      }
    }

    if ( result.place_id) {

      geolocation = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng(),
        bounds: JSON.parse( JSON.stringify( result.geometry.viewport )),
        _type: (
            [
              // google.maps.GeocoderLocationType.APPROXIMATE,
              google.maps.GeocoderLocationType.RANGE_INTERPOLATED,
              google.maps.GeocoderLocationType.ROOFTOP
            ].indexOf( result.types[0] ) > -1
        ) ? AddressType.PointOnMap : AddressType.Generic
      };

      if (clicked) {
        locationToPatch.Center = {
          lat: geolocation.lat,
          lng: geolocation.lng
        };

        geolocation._type = "_fixed_";
      } else {
        locationToPatch.Center = null;
      }

      const isCountry = result.types.indexOf("country") > -1;

      if(isCity) {
        geolocation._type = "_fixed_";
      }

      if(isCountry) {
        searchedCountry = result.address_components['0'].short_name;
      }

      locationToPatch.Bounds = geolocation.bounds;

    } else {
      Log.w("No address found for", address_text);
      locationToPatch.Address = address_text;
    }

    return {
      locationToPatch,
      geolocation,
      address_text,
      searchedCountry
    }
  }

  static applyRestrictionsOnAutocomplete(autocompleteComponent,opt){
      if(autocompleteComponent && opt){
        autocompleteComponent.setComponentRestrictions(opt);
      }
  }

  static applyEventOnAutocomplete(autocompleteComponent,event,callback){
    if(autocompleteComponent && event && callback){
      autocompleteComponent.addListener(event,(e)=>{
        callback(e);
      })
    }
  }

  static applyEventOnAutocompleteChangePlace(autocompleteComponent,callback){
    GoogleSearch.applyEventOnAutocomplete(autocompleteComponent,'place_changed',callback);
  }

  static plainGeocode({coordinates,resolve}){
    new google.maps.Geocoder().geocode({'location': coordinates},function (results) {
      for(let result of results) {
        if (result.types[0] === 'postal_code') {
          resolve(result.formatted_address);
          return
        }
      }
    })
  }

  geocode(address, location, force_fixed_point,options,resolve,reject,trigger){

    if ( location ) {
      if ( ! ( location instanceof google.maps.LatLng ) ) {
        location = new google.maps.LatLng(location.lat, location.lng);
      }
    }

    // Ask Geocoder for retrieving Geo address
    this.Geocoder.geocode({address: address, location: location}, (result, status) => {

      Log.l("Results", status, result);

      if (status !== google.maps.GeocoderStatus.OK) {
        Log.warn("No results found for", address);
        reject(Errors.NO_ADDRESS_FOUND);

      } else {

        /* filter resultset in order to remove all not valid addresses */
        result = ( () => {
          if ( !options.AllowedAddressType || !options.AllowedAddressType.length ) {
            return result;
          }
          let location = [];
          for ( let l of result ) {
            for( let t of l.types ) {
              if ( options.AllowedAddressType.indexOf(t) > -1 ) {
                location.push( l );
                break;
              }
            }
          }
          return location;
        })();

        if ( result.length <= 0 ) {
          // error
          reject(Errors.NO_ADDRESS_FOUND);
        } else {

          // We have a valid address: choose the first one
          let bounds = result[0].geometry.viewport || result[0].geometry.bounds;
          if ( !bounds ) {
            // location is not valid
            Log.warn("Invalid location or bounds", result[0].geometry);
            return reject(Errors.NO_ADDRESS_FOUND);
          }

          let fixed_point = ( () => {
            if ( location || force_fixed_point ) {
              return { lat: result[0].geometry.location.lat(), lng: result[0].geometry.location.lng(), _type: AddressType.Fixed, bounds: JSON.parse( JSON.stringify(result[0].geometry.viewport)) };
            } else {
              return {
                lat: result[0].geometry.location.lat(),
                lng: result[0].geometry.location.lng(),
                bounds: JSON.parse( JSON.stringify(result[0].geometry.viewport)),
                _type:
                    (
                        [
                          // google.maps.GeocoderLocationType.APPROXIMATE,
                          google.maps.GeocoderLocationType.RANGE_INTERPOLATED,
                          google.maps.GeocoderLocationType.ROOFTOP
                        ].indexOf( result[0].geometry.location_type ) > -1
                    ) ? AddressType.PointOnMap : AddressType.Generic
              };
            }
          })();

          trigger("change-address", address || result[0].formatted_address, fixed_point);

          resolve({bounds: bounds, results: result});
        }
      }
    });
  }


}


export default GoogleSearch
